import './style/bolmateBadge.scss';

import classNames from 'classnames';

import React, {ReactNode} from 'react';

import BolmateTooltip from '../tooltip/bolmateTooltip';

export type BolmateBadgeColor = 'blue' | 'green' | 'red' | 'orange' | 'gold' | 'gray';
export type BolmateBadgeSize = 'small' | 'normal' | 'big';

interface Props {
    label: ReactNode;
    color?: BolmateBadgeColor;
    size?: BolmateBadgeSize;
    /** Pale tinted fill + subtle coloured border + coloured content, instead of
     * the solid fill. Colour follows the `color` prop. Defaults to false. */
    outline?: boolean;
    tooltip?: ReactNode;
    /** Extra class on the tooltip portal element (e.g. to allow wrapping). */
    tooltipClassName?: string;
    /** Keep the tooltip open while hovered, so links inside stay clickable. */
    tooltipInteractive?: boolean;
    className?: string;
}

export default function BolmateBadge(props: Props) {
    const {
        label,
        color = 'blue',
        size = 'normal',
        outline = false,
        tooltip,
        tooltipClassName,
        tooltipInteractive,
        className
    } = props;

    const element = (
        <span
            className={classNames('bolmate-badge', `color-${color}`, `size-${size}`, outline && 'outline', className)}
        >
            {label}
        </span>
    );

    if (tooltip) {
        return (
            <BolmateTooltip text={tooltip} className={tooltipClassName} interactive={tooltipInteractive}>
                {element}
            </BolmateTooltip>
        );
    }

    return element;
}
